<template>
  <b-modal
    id="modal-delete-bank-account"
    v-model="showModal"
    hide-header
    hide-footer
    centered
    no-close-on-backdrop
    @hidden="onCancel"
  >
    <div class="text-center">
      <!-- Warning Icon -->
      <div class="flex justify-center mb-3">
        <img
          src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
          alt="Warning"
          class="w-[105px] h-auto"
        >
      </div>

      <!-- Title -->
      <h4 class="text-xl text-[#1E293B] mb-1">
        Hapus Rekening?
      </h4>

      <!-- Description -->
      <p class=" text-[#64748B] mb-2 leading-relaxed">
        Apakah Anda yakin ingin menghapus rekening <strong class="font-semibold text-[#1E293B]">{{ bankInfo }}?</strong>
      </p>

      <!-- Action Buttons -->
      <div class="flex items-center gap-3 justify-center">
        <button
          type="button"
          class="flex-1 py-2.5 px-4 rounded-xl border border-gray-300 bg-white text-[#1E293B] hover:bg-gray-50 font-medium text-sm transition-colors cursor-pointer"
          :disabled="isLoading"
          @click="onCancel"
        >
          Batal
        </button>
        <button
          type="button"
          class="flex-1 py-2.5 px-4 rounded-xl bg-[#F95015] hover:bg-[#E04510] text-white border-0 font-medium text-sm transition-colors cursor-pointer flex items-center justify-center"
          :disabled="isLoading"
          @click="onConfirm"
        >
          <b-spinner
            v-if="isLoading"
            small
            class="mr-1"
          />
          Hapus
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { apiDeleteBankAccount } from './service/api.bankAccount.service'

export default {
  name: 'ModalDeleteBankAccount',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    bankData: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    showModal: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close')
        }
      },
    },
    bankInfo() {
      if (!this.bankData) return ''
      const parts = [
        this.bankData.bank_name,
        this.bankData.account_no,
        this.bankData.account_name || this.bankData.bank_owner_name,
      ].filter(Boolean)
      return parts.join(' - ')
    },
  },
  methods: {
    getBankId(item) {
      return Number(item?.bank_account_id || item?.id || item)
    },
    onCancel() {
      this.$emit('close')
    },
    async onConfirm() {
      if (!this.bankData) return
      const id = this.getBankId(this.bankData)
      this.isLoading = true
      try {
        await apiDeleteBankAccount(id)
        this.$toast_success({ message: 'Rekening berhasil dihapus' })
        this.$emit('deleted', id)
        this.$emit('close')
      } catch (error) {
        this.$toast_error({ message: error?.response?.data?.message || 'Gagal menghapus rekening' })
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss">
#modal-delete-bank-account {
  .modal-dialog {
    max-width: 480px;
    margin: 1.75rem auto;
  }
  @media (max-width: 576px) {
    .modal-dialog {
      margin: 1rem;
    }
  }
  .modal-content {
    border-radius: 20px !important;
    border: none !important;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
    padding: 2rem !important;
  }
  .modal-body {
    padding: 0 !important;
  }
}
</style>
